"use strict";

var _slicedToArray = require("/var/www/html/tabulaRx/client/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectSpread = require("/var/www/html/tabulaRx/client/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MAX_RESULTS = exports.DEFAULT_INPUT_DEBOUNCE = void 0, exports.default = ReactSearchAutocomplete;

var _templateObject,
    _react = _interopRequireWildcard(require("react")),
    _propTypes = _interopRequireDefault(require("prop-types")),
    _fuse = _interopRequireDefault(require("fuse.js")),
    _config = require("../config/config"),
    _Results = _interopRequireDefault(require("./Results")),
    _SearchInput = _interopRequireDefault(require("./SearchInput")),
    _styledComponents = _interopRequireWildcard(require("styled-components")),
    _utils = require("../utils/utils");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
      c = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(a) {
    return a ? c : b;
  })(a);
}

function _interopRequireWildcard(a, b) {
  if (!b && a && a.__esModule) return a;
  if (null === a || "object" != typeof a && "function" != typeof a) return {
    default: a
  };

  var c = _getRequireWildcardCache(b);

  if (c && c.has(a)) return c.get(a);
  var d = {},
      e = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var f in a) {
    if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
      var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
      g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
    }
  }

  return d.default = a, c && c.set(a, d), d;
}

function _taggedTemplateLiteral(a, b) {
  return b || (b = a.slice(0)), Object.freeze(Object.defineProperties(a, {
    raw: {
      value: Object.freeze(b)
    }
  }));
}

var DEFAULT_INPUT_DEBOUNCE = 200;
exports.DEFAULT_INPUT_DEBOUNCE = 200;
var MAX_RESULTS = 10;
exports.MAX_RESULTS = 10;

function ReactSearchAutocomplete(a) {
  var b = a.items,
      c = a.fuseOptions,
      d = a.inputDebounce,
      e = a.onSearch,
      f = a.onHover,
      g = a.onSelect,
      h = a.onFocus,
      i = a.onClear,
      j = a.showIcon,
      k = a.showClear,
      l = a.maxResults,
      m = a.placeholder,
      n = a.autoFocus,
      o = a.styling,
      p = a.resultStringKeyName,
      q = a.inputSearchString,
      r = a.formatResult,
      s = _objectSpread({}, _config.defaultTheme, o),
      t = _objectSpread({}, _config.defaultFuseOptions, c),
      u = new _fuse.default(b, t);

  u.setCollection(b);

  var _ref = (0, _react.useState)(q),
      _ref2 = _slicedToArray(_ref, 2),
      v = _ref2[0],
      w = _ref2[1],
      _ref3 = (0, _react.useState)(),
      _ref4 = _slicedToArray(_ref3, 2),
      x = _ref4[0],
      y = _ref4[1],
      z = function z(a) {
    var b = [];
    0 < (null === a || void 0 === a ? void 0 : a.length) ? (b = B(a), y(b), e(a, b)) : y(b);
  },
      A = _react.default.useCallback(0 < d ? (0, _utils.debounce)(function (a) {
    return z(a);
  }, d) : function (a) {
    return z(a);
  }, [b]);

  (0, _react.useEffect)(function () {
    w(q);
  }, [q]), (0, _react.useEffect)(function () {
    0 < (null === v || void 0 === v ? void 0 : v.length) && 0 < (null === x || void 0 === x ? void 0 : x.length) && y(B(v));
  }, [b]);

  var B = function B(a) {
    return u.search(a, {
      limit: l
    }).map(function (a) {
      return _objectSpread({}, a.item);
    }).slice(0, l);
  };

  return _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: s
  }, _react.default.createElement(StyledReactSearchAutocomplete, null, _react.default.createElement("div", {
    className: "wrapper"
  }, _react.default.createElement(_SearchInput.default, {
    searchString: v,
    setSearchString: function setSearchString(a) {
      var b = a.target;
      var c = b.value;
      w(c), A(c);
    },
    autoFocus: n,
    onBlur: function onBlur() {
      return y([]);
    },
    onFocus: h,
    onClear: i,
    placeholder: m,
    showIcon: j,
    showClear: k
  }), _react.default.createElement(_Results.default, {
    results: x,
    onClick: function onClick(a) {
      y([]), g(a);
    },
    onHover: f,
    setSearchString: w,
    showIcon: j,
    maxResults: l,
    resultStringKeyName: p,
    formatResult: r
  }))));
}

ReactSearchAutocomplete.defaultProps = {
  items: [],
  fuseOptions: _config.defaultFuseOptions,
  onSearch: function onSearch() {},
  onHover: function onHover() {},
  onSelect: function onSelect() {},
  onClear: function onClear() {},
  inputDebounce: 200,
  showIcon: !0,
  showClear: !0,
  maxResults: 10,
  placeholder: "",
  autoFocus: !1,
  onFocus: function onFocus() {},
  styling: {},
  resultStringKeyName: "name",
  inputSearchString: "",
  formatResult: function formatResult(a) {
    return a;
  }
}, ReactSearchAutocomplete.propTypes = {
  items: _propTypes.default.array,
  fuseOptions: _propTypes.default.object,
  inputDebounce: _propTypes.default.number,
  onSearch: _propTypes.default.func,
  onHover: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  showIcon: _propTypes.default.bool,
  showClear: _propTypes.default.bool,
  maxResults: _propTypes.default.number,
  placeholder: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  styling: _propTypes.default.object,
  resultStringKeyName: _propTypes.default.string,
  inputSearchString: _propTypes.default.string,
  formatResult: _propTypes.default.func
};

var StyledReactSearchAutocomplete = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  height: ", ";\n\n  > .wrapper {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    border: ", ";\n    border-radius: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    font-size: ", ";\n    font-family: ", ";\n\n    z-index: ", ";\n\n    &:hover {\n      box-shadow: ", ";\n    }\n    &:active {\n      box-shadow: ", ";\n    }\n    &:focus-within {\n      box-shadow: ", ";\n    }\n  }\n"])), function (a) {
  return parseInt(a.theme.height) + 2 + "px";
}, function (a) {
  return a.theme.border;
}, function (a) {
  return a.theme.borderRadius;
}, function (a) {
  return a.theme.backgroundColor;
}, function (a) {
  return a.theme.color;
}, function (a) {
  return a.theme.fontSize;
}, function (a) {
  return a.theme.fontFamily;
}, function (a) {
  return a.theme.zIndex;
}, function (a) {
  return a.theme.boxShadow;
}, function (a) {
  return a.theme.boxShadow;
}, function (a) {
  return a.theme.boxShadow;
});